import { render, staticRenderFns } from "./ot-documents-index.vue?vue&type=template&id=4f6f8b54&scoped=true&"
import script from "./ot-documents-index.vue?vue&type=script&lang=ts&"
export * from "./ot-documents-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-documents-index.vue?vue&type=style&index=0&id=4f6f8b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f8b54",
  null
  
)

export default component.exports